import { render, staticRenderFns } from "./TransactionStatus.vue?vue&type=template&id=4ec2fdf4&"
import script from "./TransactionStatus.vue?vue&type=script&lang=js&"
export * from "./TransactionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports